module.exports = __webpack_public_path__ + "media/src/assets/Images/Arrow-Right-f198086c931c316024470ac6b0e2b71c.svg";